module.exports = "<span ng-bind=\"$parent.row.created_at | date:'MMM d, y'\"></span>"